import React from 'react';

import { Content as CommonContent } from '../common/Types.jsx';
import { withBlockRendering } from '../utility/Config.jsx';
import ContentContainer from '../common/ContentContainer.jsx';
import { Component as ItemMetaComponent, TypeConfig as ItemMetaTypeConfig } from './ItemMeta.jsx';
import * as CellItemImage from '../common/CellItemImage.jsx';
import * as ItemContainer from '../common/ItemContainer.jsx';
import Name from '../utility/Name.jsx';
import * as Signature from '../common/Signature.jsx';
import { Component as StatementComponent, TypeConfig as StatementTypeConfig } from './Statement.jsx';
import Token from '../utility/Token.jsx';
import { default as _TypeConfig } from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

const Blocks = {
    get: (group, data) => [
        ...CommonContent.get(group),
        {
            id: 'itemSeparator',
            dataType: 'separator',
            display: 'Item Detail',
            group
        },
        {
            id: Name.Block.Inventory.Image,
            component: CellItemImage.Component,
            config: {
                Block: CellItemImage.TypeConfig.panel.block(),
                Style: CellItemImage.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: ItemMetaComponent,
            config: {
                Block: ItemMetaTypeConfig.panel.block(),
                Style: ItemMetaTypeConfig.panel.style(),
                Description: ItemMetaTypeConfig.panel.description(),
                Label: ItemMetaTypeConfig.panel.label(),
                Value: ItemMetaTypeConfig.panel.value(data)
            },
            display: 'Item Meta',
            group,
            image: ''
        },
        {
            id: 'certificateSeparator',
            dataType: 'separator',
            display: 'Certificate of Authenticity',
            group
        },
        {
            id: Name.Block.AuthenticityStatement,
            component: StatementComponent,
            config: {
                Block: StatementTypeConfig.panel.block(),
                Style: StatementTypeConfig.panel.style(),
            },
            display: 'Authenticity Statement',
            group,
            image: ''
        },
        {
            id: Name.Block.Signature,
            component: Signature.Component,
            config: {
                Block: Signature.TypeConfig.panel.block(true),
                Style: Signature.TypeConfig.panel.style(),
                Description: Signature.TypeConfig.panel.description(),
                Label: Signature.TypeConfig.panel.label(),
                Value: Signature.TypeConfig.panel.value()
            },
            display: 'Signature Line',
            group,
            image: ''
        }
    ]
}

function Page(props) {
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    const data = props.data || {};
    let className = 'itemContainer';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <ItemContainer.Page
            {...props}
            className={className}
            itemContentContainer={ItemContentContainer}
            items={data.Inventory}
            visibility={props.config && props.config.config && props.config.config.Visibility}
            visibilityHash={visibilityHash} />
    );
}

const _ItemContentContainer = withBlockRendering(ContentContainer, Blocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
            break;
    }
});
function ItemContentContainer(props) {
    let config = props.contentConfig;
    if (!config && props.config && props.config.config && props.config.config.Block && props.config.config.Block.design && props.config.config.Block.design.Config) {
        config = Utilities.Config.getDeepCopy(props.config.config.Block.design);
    }
    let componentData;
    if (props.componentData) {
        componentData = props.componentData;
        if (componentData && componentData.length) {
            componentData = componentData[0];
        }
    } else if (props.data && props.data.Inventory && props.data.Inventory.length) {
        componentData = { ...props.data.Inventory[0] };
        // if (componentData.Images && componentData.Images.length) {
        //     componentData.image = { ...componentData.Images[0] };
        // }
    }
    if (!componentData) {
        componentData = {};
    }
    return <_ItemContentContainer {...props} {...componentData} contentConfig={config} />
}

const TypeConfig = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "maxHeight": {
                                "unit": "px",
                                "value": "600"
                            },
                            "maxWidth": {
                                "unit": "px",
                                "value": "600"
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {},
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ItemMetaTypeConfig.defaultDesign(data)
                        }
                    },
                    "id": `${Name.Block.Inventory.Meta}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.CertificateItem
    }),
    panel: {
        block: () => ItemContainer.TypeConfig.panel.block('block', Name.Content.CertificateItem),
        style: () => _TypeConfig.panel.layoutStyle('block', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Edition Info', name: Token.Inventory.Edition, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Edition, config, Name.Block.Inventory.Meta) },
                    { display: 'Created Date', name: Token.Date, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Date, config, Name.Block.Inventory.Meta) },
                    { display: 'Medium', name: Token.Inventory.Medium, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Medium, config, Name.Block.Inventory.Meta) },
                    { display: 'Signature Placement', name: Token.Inventory.Signature, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Signature, config, Name.Block.Inventory.Meta) },
                    { display: 'Dimensions', name: Token.Inventory.Dimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Dimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Number', name: Token.Inventory.Number, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Number, config, Name.Block.Inventory.Meta) },
                    { display: 'SKU', name: Token.Inventory.SKU, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.SKU, config, Name.Block.Inventory.Meta) },
                    { display: 'Retail Price', name: Token.Inventory.Price, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Price, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Prices', name: Token.Inventory.AlternatePrices, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternatePrices, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Notes', name: Token.Notes, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Notes, config, Name.Block.Inventory.Meta) },
                    { display: 'Artist Biography', name: Token.Artist.Biography, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Artist.Biography, config, Name.Block.Inventory.Meta) },
                    { display: 'Provenance', name: Token.Inventory.Provenance, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Provenance, config, Name.Block.Inventory.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

export {
    Blocks,
    ItemContentContainer as ContentContainer,
    Page,
    TypeConfig
};